import React, { useCallback, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";

// material ui icons
import Close from "@material-ui/icons/Close";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Snackbars from "components/Snackbar/Snackbar.js";

// Hooks
import { useColorTheme } from "hooks/useColorTheme";

// styles
import { TitleWrapperStyled, TitleStyled, styles } from "./styles";

// action creators
import {
  clearError,
  setError,
} from "redux/ducks/newBrand";
import { useForm } from "hooks/useForm";
import { addNewBrandV2 } from "redux/actions/brands/brandsAction_V2";
import { editBrandNameV2 } from "redux/actions/brands/brandsAction_V2";

const useStyles = makeStyles(styles);

function NewBrand() {
  const { isEdit, id } = useParams();
  const dispatch = useDispatch();
  // selectors
  const { token } = useSelector(state => state.login)
  const { brandName } = useSelector(state => state.brandsReducer)
  const colorBg = useSelector((state) => state.config.colorBg);

  const {inputValues, handleInputOnChange, handleNewValues  } = useForm({
    name: ''
  })

  const { name } = inputValues
  const error = useSelector((state) => state.newBrand.error, shallowEqual);
  const errorMessage = useSelector(
    (state) => state.newBrand.errorMessage,
    shallowEqual
  );
  // Custom hooks
  const { color } = useColorTheme(colorBg);
  const classes = useStyles();
  let history = useHistory();
  // validation state
  const [nameState, setNameState] = React.useState("");

  // calls
  const sendData = (body) => {
      dispatch(addNewBrandV2(body, token));
      history.push('/admin/marcas')
    }
    
    const editData = (id, body) => {
      dispatch(editBrandNameV2(id, body, token));
      history.push('/admin/marcas')
    }
  const clearSnackbar = useCallback(() => {
    dispatch(clearError());
  }, []);
  const setSnackbar = useCallback((error) => {
    dispatch(setError(error));
  }, []);
  useEffect(() => {
    isEdit && id && handleNewValues({
      name: brandName[id]?.name
    })
    // eslint-disable-next-line
  }, [ brandName ]);

  const handleSubmit = () => {
    if (name === "" ) {
      setSnackbar("El campo nombre es obligatorio.");
      setNameState("error");
      return;
    }

    const body = {
      name,
    };

    isEdit ? editData(id, body) : sendData(body);
  };

  const handleGoBack = (page) => {
    history.goBack();
  };
  return (
    <React.Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color={color} icon>
              <CardIcon color={color}>
                <LocalAtmIcon />
              </CardIcon>
              <TitleWrapperStyled>
                <TitleStyled>
                  {isEdit ? "Editar marca" : "Nueva marca"}
                </TitleStyled>
                <Button
                  justIcon
                  round
                  color={color}
                  onClick={() => handleGoBack()}
                >
                  <ArrowBackIcon className={classes.buttonIcon} />
                </Button>
              </TitleWrapperStyled>
            </CardHeader>
            <CardBody>
              <form>
              <CustomInput
                  success={nameState === "success"}
                  error={nameState === "error"}
                  labelText="Nombre *"
                  id="name"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: handleInputOnChange,
                    type: "Text",
                    value: name,
                    name: 'name',
                    endAdornment:
                      nameState === "error" ? (
                        <InputAdornment position="end">
                          <Close className={classes.danger} />
                        </InputAdornment>
                      ) : (
                        undefined
                      ),
                  }}
                />

                <div className={classes.formCategory}>
                  <small>*</small> Campos requeridos
                </div>

                <Button
                  color={color}
                  onClick={handleSubmit}
                  className={classes.registerButton}
                >
                  Guardar
                </Button>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <Snackbars
        place="tr"
        color="danger"
        message={errorMessage}
        open={error}
        closeNotification={() => clearSnackbar()}
        close
      />
    </React.Fragment>
  );
}

export default React.memo(NewBrand);
